import { colors, derivedColors } from './colors'

export const withScrollbarStyled = `
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    border-radius: 10px;
    box-shadow: inset 0 0 5px #EEE;
    padding-left: 10px;
  }
  &::-webkit-scrollbar-thumb {
    background: #AAA;
    border-radius: 10px;
  }
`

export const withDisabledButtonStyled = `
  &:disabled {
    background-color: ${derivedColors.disabledBackground};
    color: ${derivedColors.disabledText};
    cursor: not-allowed;
    box-shadow: none;
    opacity: 1;
  }

  &:disabled:hover {
    background-color: ${derivedColors.disabledBackground};
  }
`
